import React from 'react';

interface ButtonProperties extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: React.ReactNode,
}

const buttonStyles = `rounded-md border border-slate-300 bg-white 
                        px-4 py-2 text-sm font-medium text-slate-700 
                        hover:bg-slate-50 hover:cursor-pointer
                        focus:outline-none focus:ring-2
                        focus:ring-blue-500 focus:ring-offset-2
                        disabled:opacity-50 disabled:cursor-not-allowed`;

const CancelButton: React.FC<ButtonProperties> = ({ children, className = '', ...properties}) => {
    return (
        <button
            {...properties}
            className={`${buttonStyles} ${className}`}
        >
            {children}
        </button>
    );
};

export default CancelButton;
